<template>
  <!-- @keyup="atKeyup" -->
  <div id="auto-complete" v-click-outside="closeDropdown">
    <label v-html="label" v-if="label"></label>
    <div
      class="auto-complete-part"
      @click.prevent="toggleDropdown(true)"
      ref="auto-complete-part"
    >
      <div class="selected-option" ref="selected-option">
        <div class="selected-text">
          {{ selected ? selected.value : placeholderText }}
        </div>
        <div class="delete-button" v-if="needDelete" @click.stop="deleteText">
          <img src="/static/icons/delete-icon.svg" />
        </div>
      </div>
      <input class="filter-input" v-model="filterWord" ref="input" />
    </div>
    <div
      class="dropdown-options-part custom-scrollbar"
      ref="dropdown-options-part"
    >
      <div
        class="option-item"
        v-if="canAddNewOption && filterWord && filterWord.length > 0"
        @click="addNewOption"
      >
        {{ filterWord }}
      </div>
      <div
        class="option-item-no-selectable"
        v-else-if="
          this.canAddNewOption === false && this.filteredOptions.length === 0
        "
      >
        {{ noOptionText }}
      </div>
      <div
        class="option-item"
        :class="{
          selected: selected && selected === item,
          onhover: hoveredElement === index
        }"
        v-for="(item, index) in filteredOptions"
        :key="index"
        @click="selectedChanged(item)"
      >
        {{ item.value }}
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "AutoComplete",
  props: {
    canAddNewOption: {
      type: Boolean,
      required: false,
      default: true
    },
    keys: {
      type: [Object, Array],
      required: true
    },
    values: {
      type: [Object, Array],
      required: true
    },
    label: {
      type: String,
      required: false
    },
    placeholderText: {
      type: String,
      required: false,
      default: "Válassz lentebb"
    },
    returnKey: {
      type: String,
      required: false,
      default: "key"
    },
    noOptionText: {
      type: String,
      required: false,
      default: "Nincs ilyen opció"
    },
    keepOpen: {
      type: Boolean,
      required: false,
      default: true
    },
    needDelete: {
      type: Boolean,
      required: false,
      default: true
    },
    needScroll: {
      type: Boolean,
      required: false,
      default: false
    },
    value: {
      required: false
    }
  },
  data() {
    return {
      filterWord: undefined,
      expanded: false,
      selected: undefined,
      hoveredElement: undefined,
      options: []
    };
  },
  created() {
    for (let i = 0; i < this.keys.length; i++) {
      const item = { key: this.keys[i], value: this.values[i] };
      this.options.push(item);
      this.initDefault();
    }
  },
  mounted() {
    if (this.keepOpen) {
      this.toggleDropdown();
    }
  },
  methods: {
    initDefault() {
      if (this.value) {
        const index = this.options.findIndex(x => x.key === this.value);
        this.selected = this.options[index];
      }
    },
    deleteText() {
      this.selected = undefined;
    },
    // atKeyup(evt) {
    //   if (evt.key === "ArrowDown") {
    //     if (this.hoveredElement !== undefined) {
    //       if (this.hoveredElement === this.filteredOptions.length - 1) {
    //         this.hoveredElement = 0;
    //         return;
    //       }
    //       this.hoveredElement += 1;
    //     } else {
    //       this.hoveredElement = 0;
    //     }
    //   } else if (evt.key === "ArrowUp") {
    //     if (this.hoveredElement !== undefined) {
    //       if (this.hoveredElement === 0) {
    //         this.hoveredElement = this.filteredOptions.length - 1;
    //         return;
    //       }
    //       this.hoveredElement -= 1;
    //     } else {
    //       this.hoveredElement = this.filteredOptions.length - 1;
    //     }
    //   } else if (evt.key === "Enter") {
    //     if (this.canAddNewOption || this.hoveredElement) {
    //       this.selected = this.filteredOptions[this.hoveredElement];
    //       this.hoveredElement = undefined;
    //       this.filterWord = undefined;
    //       this.closeDropdown();
    //     }
    //   }
    // },
    addNewOption() {
      this.selected = { value: this.filterWord, key: null };
      this.closeDropdown();
    },
    selectedChanged(item) {
      this.selected = item;
      // this.filterWord = undefined;
      this.closeDropdown();
    },
    toggleDropdown(clicked = false) {
      this.expanded = true;
      if (this.keepOpen) {
        this.$refs["dropdown-options-part"].style.position = "static";
      }
      this.calculateDropDownHeight();
      if (clicked) {
        this.$refs["selected-option"].style.display = "none";
        this.$refs["input"].style.display = "flex";
        if (this.needScroll) {
          setTimeout(() => {
            document.getElementById("auto-complete").scrollIntoView();
          }, 400);
        }
        this.$refs.input.focus();
      }
    },
    calculateDropDownHeight() {
      this.$anime.timeline().add({
        targets: this.$refs["dropdown-options-part"],
        height: "fit-content"
      });
    },
    closeDropdown() {
      this.$refs["selected-option"].style.display = "flex";
      this.$refs["input"].style.display = "none";
      if (this.keepOpen == false) {
        this.expanded = false;
        this.calculateDropDownHeight();
      }
    }
  },
  computed: {
    filteredOptions() {
      return this.options.filter(x => {
        if (this.filterWord) {
          // eslint-disable-next-line prettier/prettier
          return (x.value + "")
            .toLowerCase()
            .includes(this.filterWord.toLowerCase());
        } else {
          return this.options;
        }
      });
    }
  },
  watch: {
    options() {
      this.initDefault();
    },
    value: {
      immediate: true,
      handler() {
        if (this.value === undefined) {
          this.selected = undefined;
        } else {
          this.initDefault();
        }
      }
    },
    keys() {
      this.options = [];
      for (let i = 0; i < this.keys.length; i++) {
        const item = { key: this.keys[i], value: this.values[i] };
        this.options.push(item);
      }
    },
    values() {
      this.options = [];
      for (let i = 0; i < this.keys.length; i++) {
        const item = { key: this.keys[i], value: this.values[i] };
        this.options.push(item);
      }
    },
    filteredOptions() {
      this.calculateDropDownHeight();
    },
    expanded() {
      if (!this.expanded) {
        this.$refs["dropdown-options-part"].classList.remove("expanded");
        // this.$refs["icon"].classList.remove("rotated");
        this.$refs["auto-complete-part"].classList.remove("active");
      } else {
        this.$refs["dropdown-options-part"].classList.add("expanded");
        // this.$refs["icon"].classList.add("rotated");
        this.$refs["auto-complete-part"].classList.add("active");
      }
    },
    selected() {
      if (this.selected) {
        this.$emit("input", this.selected[this.returnKey]);
      } else {
        this.$emit("input", undefined);
      }
    }
  }
};
</script>

<style lang="scss" scoped>
@import "~@/styles/variables.scss";
#auto-complete {
  width: 100%;
  position: relative;
  .auto-complete-part {
    width: 100%;
    height: 40px;
    border: 1px solid #adadad;
    border-radius: 5px;
    background-color: white;
    display: flex;
    flex-direction: row;
    justify-content: space-between;
    &.active {
      box-shadow: 0 3px 10px rgba(0, 0, 0, 0.15) !important;
      border: 1px solid $color-primary !important;
    }
    .selected-option {
      display: flex;
      justify-content: space-between;
      cursor: pointer;
      width: 100%;
      padding-left: 10px;
      display: flex;
      align-items: center;
      font-size: 14px;
      .delete-button {
        img {
          height: 20px;
          padding-right: 10px;
        }
      }
    }
    .filter-input {
      background: none;
      display: none;
      flex-grow: 1;
      height: 100%;
      outline: none;
      border: none;
      font-size: 14px;
      padding-left: 10px;
      width: inherit;
    }
    .icon {
      cursor: pointer;
      display: flex;
      align-items: center;
      transition: 0.3s all ease-in-out;
      margin-right: 10px;
      transform: rotate(-180deg);
      &.rotated {
        transform: rotate(0);
      }
    }
  }
  .dropdown-options-part {
    width: 100%;
    max-height: 210px;
    visibility: hidden;
    position: absolute;
    &.expanded {
      z-index: 1;
      box-shadow: 1px 2px 8px rgba(0, 0, 0, 0.2);
      visibility: unset !important;
      background: white;
      border-radius: 8px;
    }
    .option-item-no-selectable {
      margin: 0px !important;
      height: 35px;
      display: flex;
      align-items: center;
      padding-left: 15px;
      border-radius: 8px;
      font-size: 14px;
    }
    .option-item {
      margin: 0px !important;
      height: fit-content;
      min-height: 35px;
      word-break: break-word;
      display: flex;
      align-items: center;
      padding-left: 10px;
      border-radius: 8px;
      font-size: 14px;
      padding-top: 5px;
      padding-bottom: 5px;
      &:hover {
        background: $color-primary !important;
        color: white !important;
      }
      &.onhover {
        background: $color-primary !important;
        color: white !important;
      }
      &.selected {
        color: $color-primary;
        background: rgba($color-light-primary, 0.2);
      }
    }
  }
}
label {
  padding-left: 5px;
  font-size: 13px;
  margin: 0;
}
</style>
